import { render } from "./order-table.vue?vue&type=template&id=0967bd3d&scoped=true"
import script from "./order-table.vue?vue&type=script&lang=js"
export * from "./order-table.vue?vue&type=script&lang=js"

import "./order-table.vue?vue&type=style&index=0&id=0967bd3d&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0967bd3d"]])

export default __exports__